import React from 'react';
import { KontrolSonucu } from '../utils/fiyatlandirmaKontrol';

interface Props {
  sonuc: KontrolSonucu;
  engelMetni: string;
  // Verilmezse satırda Fiyat Aralıkları düğmesi gösterilmez (sayfada ayrı düğmesi varsa)
  onAraliklar?: () => void;
}

const FiyatKontrolUyari: React.FC<Props> = ({ sonuc, engelMetni, onAraliklar }) => {
  if (!sonuc.aktif) return null;
  const ihlalVar = sonuc.ihlaller.length > 0;
  const tema = !ihlalVar
    ? sonuc.notlar.length > 0
      ? { bg: '#fffbeb', border: '#fcd34d', renk: '#92400e', ikon: 'fa-exclamation-circle', baslik: 'Fiyat kontrolü tamamlanamadı.' }
      : { bg: '#f0fdf4', border: '#86efac', renk: '#166534', ikon: 'fa-check-circle', baslik: 'Ödeme planı fiyatlandırma kurallarına uygun.' }
    : sonuc.muaf
      ? { bg: '#eff6ff', border: '#93c5fd', renk: '#1e40af', ikon: 'fa-user-shield', baslik: 'Plan fiyatlandırma kurallarının dışında — proje yöneticisi olarak devam edebilirsiniz.' }
      : { bg: '#fef2f2', border: '#fca5a5', renk: '#991b1b', ikon: 'fa-exclamation-triangle', baslik: `Ödeme planı fiyatlandırma kurallarına uymuyor. ${engelMetni}` };

  return (
    <div style={{ background: tema.bg, border: `1.5px solid ${tema.border}`, borderRadius: 12, padding: '12px 16px', display: 'flex', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap' }}>
      <i className={`fas ${tema.ikon}`} style={{ color: tema.renk, fontSize: 17, marginTop: 2 }}></i>
      <div style={{ flex: 1, minWidth: 240 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: tema.renk }}>{tema.baslik}</div>
        {ihlalVar && (
          <ul style={{ margin: '6px 0 0', paddingLeft: 18, fontSize: 12.5, color: tema.renk, lineHeight: 1.55 }}>
            {sonuc.ihlaller.map(m => <li key={m}>{m}</li>)}
          </ul>
        )}
        {sonuc.notlar.map(n => <div key={n} style={{ fontSize: 12, color: '#92400e', marginTop: 4 }}>{n}</div>)}
      </div>
      {onAraliklar && <button type="button" onClick={onAraliklar}
        style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 14px', border: 'none', borderRadius: 9, background: '#1a2440', color: '#fff', fontSize: 12.5, fontWeight: 700, cursor: 'pointer', flexShrink: 0 }}>
        <i className="fas fa-tags" style={{ fontSize: 11.5 }}></i> Fiyat Aralıkları
      </button>}
    </div>
  );
};

export default FiyatKontrolUyari;
